import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';
import { SignalTileConfigState } from 'widgets/signalTiles/signalTile/state/config/SignalTileConfigState';
import { buildSignalTileReducer } from 'widgets/signalTiles/signalTile/state/reducer';
import {
    buildSignalTileConfigSlice,
    useSignalTileConfigSlice,
} from 'widgets/signalTiles/signalTile/state/config/configslice';
import { buildSignalTileStreamSlice } from 'widgets/signalTiles/signalTile/state/stream/streamSlice';
import { selectStreamedDataState } from 'streamsState/store/streamedData/selectors';
import { ShowDataFor } from 'utils/components/ShowDataFor/ShowDataFor';

export interface RsiTileTimeSeriesDataItem {
    rsi: number;
}

export const initialRsiTileConfigState: SignalTileConfigState = {
    numWindows: 14,
    bucketSize: 5,
    showDataFor: ShowDataFor.AllDay,
};

export const selectRsiTilesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.RSI_TILE];

export const selectRsiTileState = (state: State, widgetKey: string) =>
    selectRsiTilesState(state)[widgetKey];

export const mapRsiTimeSeriesDataItem = (item: RsiTileTimeSeriesDataItem) => ({
    value: item.rsi,
});

export const rsiTileReducer = buildSignalTileReducer(
    WidgetType.RSI_TILE,
    selectRsiTileState,
    initialRsiTileConfigState
);

export const rsiConfigSlice = buildSignalTileConfigSlice(
    WidgetType.RSI_TILE,
    selectRsiTileState,
    initialRsiTileConfigState
);

export const useRsiTileConfigSlice = () =>
    useSignalTileConfigSlice(
        WidgetType.RSI_TILE,
        selectRsiTileState,
        initialRsiTileConfigState
    );

const selectRsiStreamsState = (state: State) =>
    selectStreamedDataState(state).rsiTiles;

export const buildRsiStreamSlice = () =>
    buildSignalTileStreamSlice(
        WidgetType.RSI_TILE,
        'startRsiStream',
        selectRsiStreamsState,
        mapRsiTimeSeriesDataItem,
        initialRsiTileConfigState
    );

const { reducer: rsiStreamDataReducer, selectors: rsiStreamedDataSelectors } =
    buildRsiStreamSlice();

export { rsiStreamDataReducer, rsiStreamedDataSelectors };
